import { ReactElement } from "react"
import { IArea } from "./Common"

export function ProductNotes(props: {
  area: IArea
  text: string
  fill: string
  fontSize: number
}): ReactElement {
  const text: Array<string> = []
  const maxChar = Math.round((props.area.width / props.fontSize) * 1.5)
  let cluster: Array<string> = []
  let breakCluster: boolean = false
  let i = 0
  props.text.split("").forEach((char) => {
    if (i > maxChar) {
      breakCluster = true
    }
    if ((breakCluster && char === " ") || char === "\n") {
      breakCluster = false
      text.push(cluster.join(""))
      cluster = []
      i = 0
    }
    cluster.push(char)
    i++
  })
  text.push(cluster.join(""))

  return (
    <>
      {text.map((str: string, i: number) => (
        <text
          x={props.area.offsetX}
          y={props.area.offsetY + i * 1.5 * props.fontSize}
          fontSize={props.fontSize}
          fill={props.fill}
        >
          {str}
        </text>
      ))}
    </>
  )
}
